import { HighlightedText } from '@/app/components/HighlightedText';
import { getPath } from '@/consts/paths';
import type { GlobalSearchToolkitItem } from '@/types/globalSearchApiTypes';
import { SearchItemTitle } from '../SearchItemTitle';
import { SearchItemWrapper } from '../SearchItemWrapper';
import DocumentIcon from '/public/icons/document-small.svg';

interface ToolkitItemProps {
  item: GlobalSearchToolkitItem;
}

export const ToolkitItem = ({ item }: ToolkitItemProps) => {
  return (
    <SearchItemWrapper href={getPath(item.redirect_url)}>
      <div className="flex items-center gap-2">
        <DocumentIcon className="w-5 h-5 flex-shrink-0 self-start mt-1 max-md:mt-1.5 max-md:mx-1.5 text-black" />
        <div className="flex flex-col gap-1 min-w-0">
          <SearchItemTitle truncate>{item.title}</SearchItemTitle>
          <div className="flex gap-1 max-md:flex-wrap">
            {item.category_title && (
              <p className="text-body-small text-grey-700 !leading-[140%] whitespace-nowrap max-md:whitespace-normal">
                <HighlightedText>{item.category_title}</HighlightedText>;
              </p>
            )}
            {item.short_description && (
              <p className="text-body-small text-grey-700 !leading-[140%] whitespace-nowrap max-md:whitespace-normal">
                <HighlightedText>{item.short_description}</HighlightedText>;
              </p>
            )}
            <p className="text-body-small text-grey-700 !leading-[140%] truncate">
              <HighlightedText>{item.description}</HighlightedText>
            </p>
          </div>
        </div>
      </div>
    </SearchItemWrapper>
  );
};
